<header class="sticky-header">
	<div class="container">
		<div class="text-center">
			<h2 class="titulo">STDAG</h2>
		</div>
	</div>	
</header>